/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { networkIngressUpdateIngress } from "../funcs/networkIngressUpdateIngress.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { NetworkIngress } from "../models/components/networkingress.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateNetworkIngressRequest,
  UpdateNetworkIngressSecurity,
} from "../models/operations/updatenetworkingress.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateNetworkIngressMutationVariables = {
  request: UpdateNetworkIngressRequest;
  security?: UpdateNetworkIngressSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateNetworkIngressMutationData = NetworkIngress;

export type UpdateNetworkIngressMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateIngress networkIngress
 *
 * @remarks
 * Update desired ingress settings. Enabling is expansion-gated; disabling remains available after gate removal.
 */
export function useUpdateNetworkIngressMutation(
  options?: MutationHookOptions<
    UpdateNetworkIngressMutationData,
    UpdateNetworkIngressMutationError,
    UpdateNetworkIngressMutationVariables
  >,
): UseMutationResult<
  UpdateNetworkIngressMutationData,
  UpdateNetworkIngressMutationError,
  UpdateNetworkIngressMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateNetworkIngressMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateNetworkIngress(): MutationKey {
  return ["@gram/client", "networkIngress", "updateIngress"];
}

export function buildUpdateNetworkIngressMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateNetworkIngressMutationVariables,
  ) => Promise<UpdateNetworkIngressMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateNetworkIngress(),
    mutationFn: function updateNetworkIngressMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateNetworkIngressMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(networkIngressUpdateIngress(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
